import { Group, Paper, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { ReactComponent as IconCalendar } from './img/iconCalendar.svg';
import { WorkerReference } from 'redux/Api/referencesApi/type';
import { ReferenceActionsDrawer } from 'components/ReferencesItem/ReferenceActionsDrawer';

interface ReferencesListMobileTypes {
  data: WorkerReference[];
  intersectionComponent: JSX.Element | null;
  workerId?: string;
}

export const ReferencesListMobile: FC<ReferencesListMobileTypes> = ({
  data,
  intersectionComponent,
  workerId,
}) => {
  return (
    <Stack align='stretch' justify='center' mb='lg' gap='12px'>
      {data?.length ? (
        data.map((item, index) => (
          <Paper
            shadow='0'
            p='0 0 12px 0'
            key={index}
            radius={0}
            style={{ borderBottom: '1px solid #EAF0FA' }}>
            <Group justify='space-between' wrap='nowrap'>
              <Text fw='500' fz='16px' lh='22px' c='#121922'>
                {item.name}
              </Text>
              <ReferenceActionsDrawer reference={item} workerId={workerId} />
            </Group>
            <Group my='8px' gap='8px'>
              <IconCalendar />
              <Text lh='22px' fz='16px' c='#121922'>
                {item.date ? item.date : 'Дата не указана'}
              </Text>
            </Group>
            <Group gap='8px'>
              <Text lh='18px' fz='16px' c='#71869D'>
                Создал: {item.created_by}
              </Text>
            </Group>
          </Paper>
        ))
      ) : (
        <Text fz='16px' lh='22px' c='#71869D'>
          Нет справок
        </Text>
      )}
      {intersectionComponent}
    </Stack>
  );
};
